module.exports = __webpack_public_path__ + "33be6e64ce1b76a397c9d0c6495014f3.svg";